import type { NotificationList } from "@procuremate/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

/** In-app notifications (WP-3.4): refreshed every minute and when the window regains focus. */
export const notificationKeys = { list: ["notifications"] as const };

export function useNotifications(enabled: boolean) {
  return useQuery({
    queryKey: notificationKeys.list,
    queryFn: () => api<NotificationList>("/notifications"),
    enabled,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

function useNotificationMutation<TVars>(fn: (vars: TVars) => Promise<NotificationList>) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (list) => client.setQueryData(notificationKeys.list, list),
  });
}

export const useMarkRead = () =>
  useNotificationMutation((id: string) => api<NotificationList>(`/notifications/${id}/read`, { method: "POST" }));

export const useMarkAllRead = () =>
  useNotificationMutation(() => api<NotificationList>("/notifications/read-all", { method: "POST" }));
